import type { LocalizedText } from '#contract'
import { useT } from './index.ts'

/** Renders translated text, e.g. `<Text value={view.level.name} />`. */
export function Text({ value }: { value: LocalizedText }) {
  const t = useT()
  return <>{t(value)}</>
}
